var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value)?_c('icon-base-decorative',[_c('icon-checked')],1):_c('icon-base-decorative',[_c('icon-unchecked')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }